import { useExperiment } from '@eventbrite/statsig';
import React from 'react';

export const AATest = () => {
    const { value } = useExperiment('test_ssr_experiment', 'test', false);

    return <div data-testid={`ssr-div-${value}`}></div>;
};
